import React from 'react';
import '../CSS/CodingServices.css';
import codingImg from '../Images/services/Coding Services/services-Coding.png';
import codingImgMob from '../Images/Mobile Images/services/Coding Services/service-coding-banner-image-mobile.png';
import codingBacklogImg from '../Images/services/Coding Services/coding-services-section-image.png';
import codingBacklogImgMob from '../Images/Mobile Images/services/Coding Services/clear-your-coding-backlog-section-image.png';
import aiServicesCodingImgMob from '../Images/Mobile Images/services/Coding Services/ai-services-coding-section-image.png';
import greenTick from '../Images/green-tick-icon.svg';
import { useNavigate } from 'react-router-dom';

const CodingServices: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="coding-services-hero">
        <div className="coding-services-hero-img" style={{ '--hero-bg': `url(${codingImg})`, '--hero-bg-mob': `url(${codingImgMob})`, backgroundImage: `url(${codingImg})` } as React.CSSProperties}>
          <div className="coding-services-hero-overlay" />
          <div className="coding-services-hero-content">
            <div className="coding-services-hero-subtitle">Coding Services</div>
            <div className="coding-services-hero-title">Maximize Revenue. Speed Up Reimbursement.</div>
            <div className="coding-services-hero-desc">
              Our certified coding experts help eliminate backlogs, ensure accuracy, and accelerate your revenue cycle performance.
            </div>
          </div>
        </div>
      </div>
      <div className="end_to_end_coding">
        <div className="end_to_end_coding_left">
          <div className="end_to_end_coding_title">Your End-to-End Coding <br />Partner</div>
          <div className="end_to_end_coding_desc">
            From documentation review to claim readiness, we provide full-spectrum coding support throughout the mid-cycle revenue process.
          </div>
          <button onClick={() => navigate('/contact-us#contact-us-top')} className="end_to_end_coding_btn">Contact Us</button>
        </div>
        <div className="end_to_end_coding_right">
          <div className="end_to_end_coding_card">
            <div className="end_to_end_coding_card_title">Home Health Coding</div>
            <div className="end_to_end_coding_card_desc">Maximizing Home Health payments based on PDGM through accurate coding, OASIS assessments, as well as Plan of Care (POC) reviews</div>
          </div>
          <div className="end_to_end_coding_card end_to_end_coding_card_inpatient">
            <div className="end_to_end_coding_card_title">InPatient Coding</div>
            <div className="end_to_end_coding_card_desc">Reduce AR (accounts receivable burden) through accurate and timely completion of diagnosis, PCS coding, and DRG assignment</div>
          </div>
          <div className="end_to_end_coding_card">
            <div className="end_to_end_coding_card_title">Risk Adjustment & HCC Coding</div>
            <div className="end_to_end_coding_card_desc">Proficiently identifying revenue integrity issues and opportunities through HCC Risk Adjustment guidelines</div>
          </div>
          <div className="end_to_end_coding_card end_to_end_coding_card_auditing">
            <div className="end_to_end_coding_card_title">Coding Quality Auditing</div>
            <div className="end_to_end_coding_card_desc">Customized Audits save you time and money (e.g. DRG audits)</div>
          </div>
          <div className="end_to_end_coding_card end_to_end_coding_card_cdi">
            <div className="end_to_end_coding_card_title">CDI & Provider Education</div>
            <div className="end_to_end_coding_card_desc">Enhance revenue from improved documentation and accurate CPT coding through identifying key clinical documentation gaps, recognizing query opportunities, and educating physician providers</div>
          </div>
          <div className="end_to_end_coding_card">
            <div className="end_to_end_coding_card_title">Outpatient Coding, Facility & Professional Fee</div>
            <div className="end_to_end_coding_card_desc">Ensuring codes and modifiers are driving the correct payment (i.e. from Outpatient Facility, ProFee, Clinic, Labs & Diagnostics, Recurring conditions, to those most complex Obs, SDS, ED, etc)</div>
          </div>
        </div>
      </div>
      {/* AI Services for Coding Section */}
      <div className="ai-services-coding-section">
        <div className="ai-services-coding-section-left">
          <div className="ai-services-coding-section-title">AI Services for Coding</div>
          <div className="ai-services-coding-section-subtitle">Medical Coding & Documentation</div>
          <div className="ai-services-coding-section-label">Traditional Process</div>
          <div className="ai-services-coding-section-desc">Manual chart review and ICD/ CPT assignment</div>
          <div className="ai-services-coding-section-label" style={{ marginTop: 24 }}>AI Enhancement</div>
          <div className="ai-services-coding-section-desc">NLP extracts terms from notes and suggests codes with continuous learning</div>
          <div className="ai-services-coding-section-label" style={{ marginTop: 24 }}>Outcomes</div>
          <ul className="ai-services-coding-section-list">
            <li>30% increase in coder productivity</li>
            <li>Reduced under/over-coding risks</li>
          </ul>
        </div>
        <div className="ai-services-coding-section-right">
          <picture>
            <source media="(max-width: 1100px)" srcSet={aiServicesCodingImgMob} />
            <img src={require('../Images/services/Coding Services/ai-services-coding-section-image.png')} alt="AI Services for Coding Illustration" className="ai-services-coding-section-img" />
          </picture>
        </div>
      </div>
      {/* Coding Backlog Section */}
      <div className="coding_backlog_desc">
        <div className="coding_backlog_desc_left">
          <picture>
            <source media="(max-width: 1100px)" srcSet={codingBacklogImgMob} />
            <img src={codingBacklogImg} alt="Coding Backlog Illustration" className="coding_backlog_desc_img" />
          </picture>
        </div>
        <div className="coding_backlog_desc_right">
          <div className="coding_backlog_desc_title">Clear Your Coding Backlog and Elevate Accuracy</div>
          <div className="coding_backlog_desc_bullet">
            <img src={greenTick} alt="Green Tick" className="coding_backlog_desc_tick" />
            <span>
              Achieve <b>95%+ coding accuracy</b> as verified by independent third-party audits—<b>well above the offshore industry average of 91%.</b>
            </span>
          </div>
          <div className="coding_backlog_desc_bullet">
            <img src={greenTick} alt="Green Tick" className="coding_backlog_desc_tick" />
            <span>
              Our team consists exclusively of <b>AHIMA- and AAPC-certified coders</b>, many of whom also hold <b>dual credentials as BSNs</b>, ensuring both clinical and coding expertise.
            </span>
          </div>
        </div>
      </div>
      {/* Coding Service Metrics Section */}
      <div className="coding_service_metric">
        <div className="coding_service_metric_heading">
          Quality Isn't Just a Metric—It's a Mission. Medwell360 Delivers Nothing Less.
        </div>
        <div className="coding_service_metric_row">
          <div className="coding_service_metric_item">
            <div className="coding_service_metric_value">95%</div>
            <div className="coding_service_metric_label">Accuracy by 3rd Party<br />Quality Audits</div>
          </div>
          <div className="coding_service_metric_item">
            <div className="coding_service_metric_value">99%</div>
            <div className="coding_service_metric_label">Client Satisfaction</div>
          </div>
          <div className="coding_service_metric_item">
            <div className="coding_service_metric_value">300+</div>
            <div className="coding_service_metric_label">Experienced & Certified Coders</div>
          </div>
          <div className="coding_service_metric_item">
            <div className="coding_service_metric_value">3M</div>
            <div className="coding_service_metric_label">Charts Coded Annually</div>
          </div>
        </div>
      </div>
      {/* Project Management Framework Section */}
      <div className="coding_project_framework">
        <div className="coding_project_framework_heading">Robust Project Management Framework</div>
        <div className="coding_project_framework_bubbles">
          <div className="coding_project_framework_bubble_group">
            <div className="coding_project_framework_bubble">
              <img src={require('../Images/services/Coding Services/technology-integration-icon.svg').default} alt="Technology Integration" className="coding_project_framework_icon" />
            </div>
            <div className="coding_project_framework_text_container">
              <div className="coding_project_framework_bubble_title">Technology Integration</div>
              <div className="coding_project_framework_bubble_desc">Proficient in over 20 secure IT platform integrations through our compliant contact center environments.</div>
            </div>
          </div>
          <div className="coding_project_framework_connector" />
          <div className="coding_project_framework_bubble_group">
            <div className="coding_project_framework_bubble">
              <img src={require('../Images/services/Coding Services/staff-onboarding-icon.svg').default} alt="Staff Onboarding" className="coding_project_framework_icon" />
            </div>
            <div className="coding_project_framework_text_container">
              <div className="coding_project_framework_bubble_title">Staff Onboarding</div>
              <div className="coding_project_framework_bubble_desc">We implement a streamlined, progressive onboarding process to ensure fast, accurate, and consistent service delivery.</div>
            </div>
          </div>
          <div className="coding_project_framework_connector" />
          <div className="coding_project_framework_bubble_group">
            <div className="coding_project_framework_bubble">
              <img src={require('../Images/services/Coding Services/training-icon.svg').default} alt="Training" className="coding_project_framework_icon" />
            </div>
            <div className="coding_project_framework_text_container">
              <div className="coding_project_framework_bubble_title">Training</div>
              <div className="coding_project_framework_bubble_desc">Our teams are trained directly on your content—you validate comprehension, ensuring alignment from day one.</div>
            </div>
          </div>
          <div className="coding_project_framework_connector" />
          <div className="coding_project_framework_bubble_group">
            <div className="coding_project_framework_bubble">
              <img src={require('../Images/services/Coding Services/quality-assurance-icon.svg').default} alt="Quality Assurance" className="coding_project_framework_icon" />
            </div>
            <div className="coding_project_framework_text_container">
              <div className="coding_project_framework_bubble_title">Quality Assurance</div>
              <div className="coding_project_framework_bubble_desc">Success metrics are clearly defined, and a structured remediation process is in place to continuously uphold performance standards.</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CodingServices; 